"use client";
import React, { useState } from "react";
import { motion } from "framer-motion";
import { cn } from "../utils/cn";
import Form from "./form";


export const BackgroundCellAnimation = () => {
  return (
    <div>
      <div className="relative bg-black flex justify-center overflow-hidden">
        <BackgroundCellCore />
        <div className="relative z-50 mt-40 pointer-events-none select-none">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-medium text-center bg-clip-text text-transparent bg-gradient-to-b from-neutral-100 to-neutral-400 pointer-events-none font-ttsquare">
            Contact Us
          </h1>
        </div>
      </div>

      <div>
        <Form/>
      </div>
    </div>
  );
};

const BackgroundCellCore = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  const handleMouseMove = (event) => {
    setMousePosition({ x: event.clientX, y: event.clientY });
  };

  const size = 300;
  return (
    <div onMouseMove={handleMouseMove} className="h-full absolute inset-0">
      <div className="absolute h-[20rem] inset-y-0 overflow-hidden">
        <div className="absolute h-full w-full pointer-events-none -bottom-2 z-40 bg-black [mask-image:linear-gradient(to_bottom,transparent,black)]"></div>
        <div
          className="absolute inset-0 z-20 bg-transparent"
          style={{
            maskImage: `radial-gradient(
              ${size / 4}px circle at center,
             white, transparent
            )`,
            WebkitMaskImage: `radial-gradient(
            ${size / 4}px circle at center,
            white, transparent
          )`,
            WebkitMaskPosition: `${mousePosition.x - size / 2}px ${
              mousePosition.y - size / 2
            }px`,
            WebkitMaskSize: `${size}px`,
            maskSize: `${size}px`,
            pointerEvents: "none",
            maskRepeat: "no-repeat",
            WebkitMaskRepeat: "no-repeat",
          }}
        >
          <Pattern cellClassName="border-[#FC00A1] relative z-[100]" />
        </div>
        <Pattern className="opacity-[0.5]" cellClassName="border-neutral-700" />
      </div>
    </div>
  );
};

const Pattern = ({ className, cellClassName }) => {
  const x = new Array(47).fill(0);
  const y = new Array(30).fill(0);
  const matrix = x.map((_, i) => y.map((_, j) => [i, j]));
  const [clickedCell, setClickedCell] = useState(null);

  return (
    <div className={cn("flex flex-row relative z-30", className)}>
      {matrix.map((row, rowIdx) => (
        <div
          key={`matrix-row-${rowIdx}`}
          className="flex flex-col relative z-20 border-b"
        >
          {row.map((_, colIdx) => (
            <div
              key={`matrix-col-${colIdx}`}
              className={cn(
                "bg-transparent border-l border-b border-neutral-600",
                cellClassName
              )}
              onClick={() => setClickedCell([rowIdx, colIdx])}
            >
              <motion.div
                initial={{ opacity: 0 }}
                whileHover={{ opacity: [1, 1, 1] }}
                transition={{ duration: 0.3, ease: "backOut" }}
                className="bg-[#fc00a0a4] h-12 w-12"
              ></motion.div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default BackgroundCellAnimation;
